const CONTROLLER = "/members/:user_id/profile-picture";
const PATHS = {
  ADD_PROFILE_PIC: "",
  RESET_PROFILE_PIC: "",
  GET_PROFILE_PIC: "",
};

export const ProfilePictureApiRoutesNames = Object.fromEntries(
  (Object.keys(PATHS) as Array<keyof typeof PATHS>).map((k) => [k, k])
) as {
  [K in keyof typeof PATHS]: K;
};

export const ProfilePictureApiRoutes = {
  CONTROLLER,
  PATHS,
  ADD_PROFILE_PIC: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.ADD_PROFILE_PIC}`.replace(
      ":user_id",
      String(user_id)
    ),
  RESET_PROFILE_PIC: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.RESET_PROFILE_PIC}`.replace(
      ":user_id",
      String(user_id)
    ),
};
